import * as React from "react";
import {Alert, Modal} from "react-bootstrap";
import {t} from "../i18n";


interface State {
    show? : boolean
    error? : string;
    inProgress? : boolean
}
interface Props {
    id?: string;
    icon? : JSX.Element;
    errorText?: string;
    label? : string;
    confirmTitle?: string;
    confirmText? : string;
    customCancelText? : string;
    onConfirm : () => Promise<any> | undefined,
    onCancel? : () => void, className?:string
}
export class ConfirmButton extends React.Component<Props,State>{
    _isMounted:boolean;


    constructor(props : Props){
        super(props);
        this.state = {show:false, inProgress : false};
        this._isMounted = true;
    }
    componentWillUnmount() {
        this._isMounted = false;
    }
    shouldComponentUpdate(nextProps: Readonly<Props>, nextState: Readonly<State>, nextContext: any): boolean {
        return nextProps.onConfirm == this.props.onConfirm;
    }

    cancel() {
        this.setState({show : false, error : undefined });
        if(this.props.onCancel) {
            this.props.onCancel();
        }
    }
    doDelete(e:any) {
        e.preventDefault();

        this.setState({inProgress: true}, () => {
            if(this.props.onConfirm) {

                let promise = this.props.onConfirm();
                if(promise) {
                    promise.then((closeCallback? : ()=>void)=>{
                        if(this._isMounted){
                            this.setState({show:false, inProgress : false});
                        }
                        if(closeCallback) {
                            setTimeout(()=>closeCallback(), 50);
                        }
                    }).catch(err => {
                        this.setState({show : true, error : err, inProgress : false});
                    });
                }

            } else {
                this.setState({inProgress: false});
            }
        });
    }

    getDeleteInfo() : any{
        if(this.state.error != null)  {
            return false;
        }
        return <span>{this.props.confirmText}</span>
    }
    getDeleteError() : any {
        if(this.state.error == null)  {
            return false;
        }
        return <Alert variant="danger">{this.props.errorText}</Alert>
    }
    getActions() {
        if(this.state.error != null) {
            return (
                <a className="btn btn-primary" onClick={this.cancel.bind(this)}>{t("common.continue")}</a>
            );
        }
        return (
            <div className="modal-actions">
                {this.props.customCancelText && this.props.customCancelText.length > 0 ? (
                    <button className="btn btn-secondary-popup" onClick={this.cancel.bind(this)} disabled={this.state.inProgress}>{this.props.customCancelText}</button>
                ) : (
                    <button className="btn btn-secondary-popup" onClick={this.cancel.bind(this)} disabled={this.state.inProgress}>{t("common.cancel")}</button>
                )}
                <button className="btn btn-cta" onClick={this.doDelete.bind(this)} disabled={this.state.inProgress}>{this.getLabel()}</button>
            </div>
        );
    }
    getLabel() {
        if(this.props.label) {
            return this.props.label;
        }
        return "Delete";
    }
    render(){
       return [
           <a key={Math.random()} onClick={() => { this.setState({show : true } )}} id={this.props.id ? this.props.id : ""} className={this.props.className}>
               {this.props.icon && this.props.icon} {this.getLabel()}
           </a>,
           <Modal animation={false} key={Math.random()} show={this.state.show} onHide={this.cancel.bind(this)}
                  aria-labelledby="contained-modal-title">
               <Modal.Header closeButton>
                   <Modal.Title id="contained-modal-title">{this.props.confirmTitle}</Modal.Title>
               </Modal.Header>
               <Modal.Body>
                   {this.getDeleteInfo()}
                   {this.getDeleteError()}
               </Modal.Body>
               <Modal.Footer>
                   {this.getActions()}
               </Modal.Footer>
           </Modal>
       ];
    }
}